import i18n from "../../../../Frontends/Common/utils/i18n";
export class OrderStatusService {
  constructor() {
    this.statuses = [
      { text: i18n.global.t("order_created"), status: "created" },
      { text: i18n.global.t("order_published"), status: "published" },
      { text: i18n.global.t("order_approved"), status: "approved" },
      { text: i18n.global.t("order_completed"), status: "completed" },
      { text: i18n.global.t("order_factBudgetLoaded"), status: "factBudgetLoaded" },
      { text: i18n.global.t("order_factBudgetApproved"), status: "factBudgetApproved" },
    ];
  }
  search(value) {
    return this.statuses.filter((elem) => elem.text.indexOf(value) !== -1);
  }
  async get() {
    return Promise.resolve({ data: { records: this.statuses } });
  }
}
